module.exports = __webpack_public_path__ + "img/select.b268adc8.svg";